import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// import IndexView from "./view/IndexView";
import Login from "./component/Auth/Login";
import Registration from "./component/Auth/Registration";
import Home from "./view/Dashboard/Home";
import Layout from "./component/Layout";
import Protected from "./view/Protected";
import AddMedia from "./view/managemedia/AddMedia";
import ViewMedia from "./view/managemedia/ViewMedia";
import MediaBin from "./view/managemedia/MediaBin";
import AddCourse from "./view/managecourse/AddCourse";
import ViewCourses from "./view/managecourse/ViewCourses";
import ViewCourse from "./view/managecourse/ViewCourse";
import { ToastContainer } from "react-toastify";
import AddTeacher from "./view/manageteacher/AddTeacher";
import ViewTeachers from "./view/manageteacher/ViewTeachers";
import ViewTeacher from "./view/manageteacher/ViewTeacher";
import AddAnnouncement from "./view/manageannouncement/AddAnnouncement";
import ViewAnnouncement from "./view/manageannouncement/ViewAnnouncement";
import EventCalendar from "./view/manageevent/EventCalendar";
import AddEvent from "./view/manageevent/AddEvent";
import ViewAnnouncements from "./view/manageannouncement/ViewAnnouncements";
import AddViewAbuse from "./view/manageabuseword/AddViewAbuse";
import AddChapter from "./view/managechapter/AddChapter";
import ViewChapers from "./view/managechapter/ViewChapers";
import ViewStudents from "./view/managestudent/ViewStudents";
import ViewStudent from "./view/managestudent/ViewStudent";
import ViewPurchase from "./view/managestudent/ViewPurchase";
import AddStudent from "./view/managestudent/AddStudent";
import AddMcq from "./view/managemcq/AddMcq";
import ViewMcqs from "./view/managemcq/ViewMcqs";
import AddClass from "./view/manageclass/AddClass";
import AddSection from "./view/managesection/AddSection";
import ViewClass from "./view/manageclass/ViewClass";
import ViewSection from "./view/managesection/ViewSection";
import AddSubject from "./view/managesubject/AddSubject";
import ViewSubjects from "./view/managesubject/ViewSubjects";
import AddRoom from "./view/manageroom/AddRoom";
import ViewRooms from "./view/manageroom/ViewRooms";
import LoginTeacher from "./component/TeacherAuth/LoginTeacher";
import Certificate from "./component/Certificate/Certificate";
import AddNotification from "./view/managenotification/AddNotification";
import ViewNotifications from "./view/managenotification/ViewNotifications";
import AddEmailTmplt from "./view/manageemailtemplate/AddEmailTmplt";
import FileNDocViewer from "./view/otherview/FileNDocViewer";
import ViewTestResults from "./view/managestudent/ViewTestResults";
import AddAssignmentQue from "./view/manageassignment/AddAssignmentQue";
import EmailTmpltEditor from "./view/manageemailtemplate/EmailTmpltEditor";
import SalesHeadLogin from "./component/sales/salesheadAuth/SalesHeadLogin";
import SalesHome from "./view/sales/dashboard/SalesHome";
import SalesLayout from "./component/sales/SalesLayout";
import AddSalesType from "./view/sales/managesalestype/AddSalesType";
import ViewSalesType from "./view/sales/managesalestype/ViewSalesType";
import SalesProtected from "./view/sales/SalesProtected";
import AddEmployee from "./view/sales/manageemployee/AddEmployee";
import ViewEmployees from "./view/sales/manageemployee/ViewEmployees";
import ViewEmployee from "./view/sales/manageemployee/ViewEmployee";
import AddMcqBank from "./view/managemcq/AddMcqBank";
import ViewMcqBank from "./view/managemcq/ViewMcqBank";
import ViewChapter from "./view/managechapter/ViewChapter";
import AddPlan from "./view/manageplan/AddPlan";
import CoursesForApproval from "./view/managecourse/CoursesForApproval";
import AddLeadProfile from "./view/sales/manageleadprofile/AddLeadProfile";
import ViewLeadProfiles from "./view/sales/manageleadprofile/ViewLeadProfiles";
import ViewLeadProfile from "./view/sales/manageleadprofile/ViewLeadProfile";
import ViewReferal from "./view/sales/managereferal/ViewReferal";
import AddReferal from "./view/sales/managereferal/AddReferal";
import ForgotPassAdmn from "./component/Auth/ForgotPassAdmn";
import ForgotPassTchr from "./component/TeacherAuth/ForgotPassTchr";
import ForgotPassSalesHead from "./component/sales/salesheadAuth/ForgotPassSalesHead";
import Settings from "./view/settings/Settings";
import SalesSettings from "./view/sales/settings/SalesSettings";
import AddPackage from "./view/managepackage/AddPackage";
import ViewPackages from "./view/managepackage/ViewPackages";
import ViewPackage from "./view/managepackage/ViewPackage";
import SalesAdminProfile from "./view/sales/profile/SalesAdminProfile";
import CompletedLeads from "./view/sales/manageleadprofile/CompletedLeads";
import ViewQueries from "./view/sales/managequery/ViewQueries";
import StudentSubmissions from "./view/manageassignment/StudentSubmissions";
import ViewStudentAssignment from "./view/manageassignment/ViewStudentAssignment";
import ViewAssignment from "./view/manageassignment/ViewAssignment";
import TeacherForApproval from "./view/manageteacher/TeacherForApproval";
import ViewDoubts from "./view/managecourse/ViewDoubts";
import AddExam from "./view/managemcq/AddExam";
import ViewExam from "./view/managemcq/ViewExam";
import AddExamMcq from "./view/managemcq/AddExamMcq";
import ChapterBin from "./view/managechapter/ChapterBin";
import LoginTracks from "./view/login_tracks/LoginTracks";
import GrapesEditor from "./view/GrapesJs/GrapesEditor";
import ViewPurchaselist from "./view/managestudent/ViewPurchaselist";

function App() {
  return (
    <>
      <ToastContainer />
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Routes>
          {/*------------------------ Authentication Routes / Without Token ------------------------*/}
          <Route exact path="/" index element={<Login />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/loginteacher" element={<LoginTeacher />} />
          <Route exact path="/signup" element={<Registration />} />
          <Route exact path="/forgotpassadmn" element={<ForgotPassAdmn />} />
          <Route exact path="/forgotpasstchr" element={<ForgotPassTchr />} />

          {/*------------------------ Settings Routes ------------------------*/}
          <Route
            exact
            path="settings"
            element={
              <Layout>
                <Protected Cmp={Settings} />
              </Layout>
            }
          />

          {/*------------------------ Dashboard Routes ------------------------*/}
          <Route
            exact
            path="home"
            element={
              <Layout>
                <Protected Cmp={Home} />
              </Layout>
            }
          />

          {/*------------------------ File viewer Routes ------------------------*/}
          <Route
            exact
            path="fileanddocviewer/:cid/:fileLink/:fileOf/:ctype"
            element={
              <Layout>
                <Protected Cmp={FileNDocViewer} />
              </Layout>
            }
          />
          <Route
            exact
            path="fileanddocviewer/:id/:studentid/:fileLink/nm/:stdname"
            element={
              <Layout>
                <Protected Cmp={FileNDocViewer} />
              </Layout>
            }
          />

          {/*------------------------ Manage Media Routes ------------------------*/}
          <Route
            exact
            path="/addmedia"
            element={
              <Layout>
                <Protected Cmp={AddMedia} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewmedia"
            element={
              <Layout>
                <Protected Cmp={ViewMedia} />
              </Layout>
            }
          />
          <Route
            exact
            path="/mediabin"
            element={
              <Layout>
                <Protected Cmp={MediaBin} />
              </Layout>
            }
          />

          {/*------------------------ Manage Course Routes ------------------------*/}
          {/* create */}
          <Route
            exact
            path="/addcourse"
            element={
              <Layout>
                <Protected Cmp={AddCourse} />
              </Layout>
            }
          />
          {/* edit / update */}
          <Route
            exact
            path="/addcourse/:id"
            element={
              <Layout>
                <Protected Cmp={AddCourse} />
              </Layout>
            }
          />
          {/* view all */}
          <Route
            exact
            path="/viewcourses"
            element={
              <Layout>
                <Protected Cmp={ViewCourses} />
              </Layout>
            }
          />
          {/* view all */}
          <Route
            exact
            path="/coursesforapproval"
            element={
              <Layout>
                <Protected Cmp={CoursesForApproval} />
              </Layout>
            }
          />
          {/* view single */}
          <Route
            exact
            path="/viewcourse/:id"
            element={
              <Layout>
                <Protected Cmp={ViewCourse} />
              </Layout>
            }
          />
          {/* view single other example: cfa(courses for approval) */}
          <Route
            exact
            path="/viewcourse/:id/:other"
            element={
              <Layout>
                <Protected Cmp={ViewCourse} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewdoubts/:id"
            element={
              <Layout>
                <Protected Cmp={ViewDoubts} />
              </Layout>
            }
          />

          {/*------------------------ Manage Teacher Routes ------------------------*/}
          <Route
            exact
            path="/addteacher"
            element={
              <Layout>
                <Protected Cmp={AddTeacher} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewteachers"
            element={
              <Layout>
                <Protected Cmp={ViewTeachers} />
              </Layout>
            }
          />
          <Route
            exact
            path="/tcrforaprvl"
            element={
              <Layout>
                <Protected Cmp={TeacherForApproval} />
              </Layout>
            }
          />
          {/* edit / update */}
          <Route
            exact
            path="/addteacher/:id"
            element={
              <Layout>
                <Protected Cmp={AddTeacher} />
              </Layout>
            }
          />
          {/* edit / update aprvl*/}
          <Route
            exact
            path="/addteacher/:id/:aprvl"
            element={
              <Layout>
                <Protected Cmp={AddTeacher} />
              </Layout>
            }
          />
          {/* view single */}
          <Route
            exact
            path="/viewteacher/:id"
            element={
              <Layout>
                <Protected Cmp={ViewTeacher} />
              </Layout>
            }
          />
          {/* view single */}
          <Route
            exact
            path="/viewteacher/:id/:aprvl"
            element={
              <Layout>
                <Protected Cmp={ViewTeacher} />
              </Layout>
            }
          />

          <Route
            exact
            path="/viewteacher/:id/:coid"
            element={
              <Layout>
                <Protected Cmp={ViewTeacher} />
              </Layout>
            }
          />

          {/*------------------------ Manage Student Routes ------------------------*/}
          <Route
            exact
            path="/viewstudents"
            element={
              <Layout>
                <Protected Cmp={ViewStudents} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewpurchase"
            element={
              <Layout>
                <Protected Cmp={ViewPurchase} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewpurchaselist"
            element={
              <Layout>
                <Protected Cmp={ViewPurchaselist} />
              </Layout>
            }
          />
          {/* view single */}
          <Route
            exact
            path="/viewstudent/:id"
            element={
              <Layout>
                <Protected Cmp={ViewStudent} />
              </Layout>
            }
          />
          <Route
            exact
            path="/addstudent"
            element={
              <Layout>
                <Protected Cmp={AddStudent} />
              </Layout>
            }
          />
          <Route
            exact
            path="/addstudent/:id"
            element={
              <Layout>
                <Protected Cmp={AddStudent} />
              </Layout>
            }
          />

          {/*------------------------ Manage Student - Result Routes ------------------------*/}
          <Route
            exact
            path="/viewtestresult/:sid/:sname"
            element={
              <Layout>
                <Protected Cmp={ViewTestResults} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewtestresult/:ctype/:cid/:cname"
            element={
              <Layout>
                <Protected Cmp={ViewTestResults} />
              </Layout>
            }
          />

          {/*------------------------ Manage Announcement Routes ------------------------*/}
          <Route
            exact
            path="/addannouncement"
            element={
              <Layout>
                <Protected Cmp={AddAnnouncement} />
              </Layout>
            }
          />
          <Route
            exact
            path="/addannouncement/:id"
            element={
              <Layout>
                <Protected Cmp={AddAnnouncement} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewannouncements"
            element={
              <Layout>
                <Protected Cmp={ViewAnnouncements} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewannouncement/:id"
            element={
              <Layout>
                <Protected Cmp={ViewAnnouncement} />
              </Layout>
            }
          />

          {/*------------------------ Manage Abuse Routes ------------------------*/}
          <Route
            exact
            path="/addviewabuse"
            element={
              <Layout>
                <Protected Cmp={AddViewAbuse} />
              </Layout>
            }
          />

          {/*------------------------ Event Calender Routes ------------------------*/}
          <Route
            exact
            path="/addevent"
            element={
              <Layout>
                <Protected Cmp={AddEvent} />
              </Layout>
            }
          />
          <Route
            exact
            path="/eventcalendar"
            element={
              <Layout>
                <Protected Cmp={EventCalendar} />
              </Layout>
            }
          />

          {/*------------------------ Manage Chapter Routes ------------------------*/}
          <Route
            exact
            path="/addchapter"
            element={
              <Layout>
                <Protected Cmp={AddChapter} />
              </Layout>
            }
          />
          <Route
            exact
            path="/addchapter/:id"
            element={
              <Layout>
                <Protected Cmp={AddChapter} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewchapters"
            element={
              <Layout>
                <Protected Cmp={ViewChapers} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewchapter/:id"
            element={
              <Layout>
                <Protected Cmp={ViewChapter} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewchapter/:id/course/:coid"
            element={
              <Layout>
                <Protected Cmp={ViewChapter} />
              </Layout>
            }
          />
          <Route
            exact
            path="/chapterbin"
            element={
              <Layout>
                <Protected Cmp={ChapterBin} />
              </Layout>
            }
          />

          {/*------------------------ Manage Plan ------------------------*/}
          <Route
            exact
            path="/addplan/:planof/:id"
            element={
              <Layout>
                <Protected Cmp={AddPlan} />
              </Layout>
            }
          />
          <Route
            exact
            path="/addplan/:planof/:id/:pid"
            element={
              <Layout>
                <Protected Cmp={AddPlan} />
              </Layout>
            }
          />

          {/*------------------------ Manage MCQ Routes ------------------------*/}
          {/* addmcq */}
          <Route
            exact
            path="/addmcq"
            element={
              <Layout>
                <Protected Cmp={AddMcq} />
              </Layout>
            }
          />
          {/* addmcq/:base/:id/:adfrom */}
          <Route
            exact
            path="/addmcq/:base/:id/:adfrom"
            element={
              <Layout>
                <Protected Cmp={AddMcq} />
              </Layout>
            }
          />
          {/* addmcq/:base/:id/:adfrom/mbid/:mbid */}
          <Route
            exact
            path="/addmcq/:base/:id/:adfrom/mbid/:mbid"
            element={
              <Layout>
                <Protected Cmp={AddMcq} />
              </Layout>
            }
          />
          {/* addmcq/:base/:id/:adfrom/iscfa/:cfa */}
          <Route
            exact
            path="/addmcq/:base/:id/:adfrom/iscfa/:cfa"
            element={
              <Layout>
                <Protected Cmp={AddMcq} />
              </Layout>
            }
          />
          {/* addmcq/:mcqid/:id/:upfrom/:adfrom/sec/:snm/mbid/:mbidForEdit */}
          <Route
            exact
            path="/addmcq/:mcqid/:id/:upfrom/:adfrom/sec/:snm/mbid/:mbidForEdit"
            element={
              <Layout>
                <Protected Cmp={AddMcq} />
              </Layout>
            }
          />
          {/* addexammcq */}
          <Route
            exact
            path="/addexammcq"
            element={
              <Layout>
                <Protected Cmp={AddMcq} />
              </Layout>
            }
          />

          {/* view */}
          <Route
            exact
            path="/viewmcqs/:base/:id/:upfrom"
            element={
              <Layout>
                <Protected Cmp={ViewMcqs} />
              </Layout>
            }
          />

          {/* mcqbank */}
          <Route
            exact
            path="/addmcqbank"
            element={
              <Layout>
                <Protected Cmp={AddMcqBank} />
              </Layout>
            }
          />
          <Route
            exact
            path="/addmcqbank/:id"
            element={
              <Layout>
                <Protected Cmp={AddMcqBank} />
              </Layout>
            }
          />
          {/* add exam */}
          <Route
            exact
            path="/addexam"
            element={
              <Layout>
                <Protected Cmp={AddExam} />
              </Layout>
            }
          />
          <Route
            exact
            path="/addexam/:id"
            element={
              <Layout>
                <Protected Cmp={AddExam} />
              </Layout>
            }
          />

          {/* view bank */}
          <Route
            exact
            path="/viewmcqbank"
            element={
              <Layout>
                <Protected Cmp={ViewMcqBank} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewmcqbank/:bankfor/:id"
            element={
              <Layout>
                <Protected Cmp={ViewMcqBank} />
              </Layout>
            }
          />
          {/* view exam */}
          <Route
            exact
            path="/viewexams"
            element={
              <Layout>
                <Protected Cmp={ViewExam} />
              </Layout>
            }
          />

          {/*------------------------ Manage Class Routes ------------------------*/}
          <Route
            exact
            path="/addclass"
            element={
              <Layout>
                <Protected Cmp={AddClass} />
              </Layout>
            }
          />
          <Route
            exact
            path="/addclass/:id"
            element={
              <Layout>
                <Protected Cmp={AddClass} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewclass"
            element={
              <Layout>
                <Protected Cmp={ViewClass} />
              </Layout>
            }
          />

          {/*------------------------ Manage Section Routes ------------------------*/}
          <Route
            exact
            path="/addsection"
            element={
              <Layout>
                <Protected Cmp={AddSection} />
              </Layout>
            }
          />
          <Route
            exact
            path="/addsection/:id"
            element={
              <Layout>
                <Protected Cmp={AddSection} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewsection"
            element={
              <Layout>
                <Protected Cmp={ViewSection} />
              </Layout>
            }
          />

          {/*------------------------ Manage Subject Routes ------------------------*/}
          <Route
            exact
            path="/addsubject"
            element={
              <Layout>
                <Protected Cmp={AddSubject} />
              </Layout>
            }
          />
          <Route
            exact
            path="/addsubject/:id"
            element={
              <Layout>
                <Protected Cmp={AddSubject} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewsubjects"
            element={
              <Layout>
                <Protected Cmp={ViewSubjects} />
              </Layout>
            }
          />

          {/*------------------------ Manage Room Routes ------------------------*/}
          <Route
            exact
            path="/addroom"
            element={
              <Layout>
                <Protected Cmp={AddRoom} />
              </Layout>
            }
          />
          <Route
            exact
            path="/addroom/:id"
            element={
              <Layout>
                <Protected Cmp={AddRoom} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewrooms"
            element={
              <Layout>
                <Protected Cmp={ViewRooms} />
              </Layout>
            }
          />

          {/*------------------------ Manage certificate Routes ------------------------*/}
          <Route
            exact
            path="/certificate1"
            element={
              <Layout>
                <Protected Cmp={Certificate} />
              </Layout>
            }
          />

          {/*------------------------ Manage Notification Routes ------------------------*/}
          <Route
            exact
            path="/addnotification"
            element={
              <Layout>
                <Protected Cmp={AddNotification} />
              </Layout>
            }
          />
          <Route
            exact
            path="/addnotification/:id"
            element={
              <Layout>
                <Protected Cmp={AddNotification} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewnotifications"
            element={
              <Layout>
                <Protected Cmp={ViewNotifications} />
              </Layout>
            }
          />

          {/*------------------------ Manage Email template Routes ------------------------*/}
          <Route
            exact
            path="/addemailtemplate"
            element={
              <Layout>
                <Protected Cmp={AddEmailTmplt} />
              </Layout>
            }
          />
          <Route
            exact
            path="/emailtmplteditor/:eid/:tmpltfor"
            element={
              <Layout>
                <Protected Cmp={EmailTmpltEditor} />
              </Layout>
            }
          />

          {/*------------------------ Manage AssignmentQue Routes ------------------------*/}
          <Route
            exact
            path="/addassignmentque"
            element={
              <Layout>
                <Protected Cmp={AddAssignmentQue} />
              </Layout>
            }
          />
          <Route
            exact
            path="/addassignmentque/:id/:ctype/:cid"
            element={
              <Layout>
                <Protected Cmp={AddAssignmentQue} />
              </Layout>
            }
          />
          <Route
            exact
            path="/studentsubmissions/:id"
            element={
              <Layout>
                <Protected Cmp={StudentSubmissions} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewstudentassignment/:id/:studentid/:stdname"
            element={
              <Layout>
                <Protected Cmp={ViewStudentAssignment} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewassignments"
            element={
              <Layout>
                <Protected Cmp={ViewAssignment} />
              </Layout>
            }
          />

          {/*------------------------ Manage Package Routes ------------------------*/}
          <Route
            exact
            path="/addpackage"
            element={
              <Layout>
                <Protected Cmp={AddPackage} />
              </Layout>
            }
          />
          <Route
            exact
            path="/addpackage/:id"
            element={
              <Layout>
                <Protected Cmp={AddPackage} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewpackages"
            element={
              <Layout>
                <Protected Cmp={ViewPackages} />
              </Layout>
            }
          />
          <Route
            exact
            path="/viewpackage/:id"
            element={
              <Layout>
                <Protected Cmp={ViewPackage} />
              </Layout>
            }
          />

             {/*------------------------ login tracks Routes ------------------------*/}

          <Route
            exact
            path="/logintracks"
            element={
              <Layout>
                <Protected Cmp={LoginTracks} />
              </Layout>
            }
          />    
             {/*------------------------ grapes js ------------------------*/}

          <Route
            exact
            path="/grapesjs"
            element={
              <Layout>
                <Protected Cmp={GrapesEditor} />
              </Layout>
            }
          />    
            

          {/* ============================================================================================================ */}
          {/* -------------------------------------------- sales related routes  ----------------------------------------- */}
          {/* ============================================================================================================ */}

          <Route exact path="/loginsaleshead" element={<SalesHeadLogin />} />
          <Route
            exact
            path="/forgotpassslhead"
            element={<ForgotPassSalesHead />}
          />

          {/*------------------------ adminsettings Routes ------------------------*/}
          <Route
            exact
            path="salessettings"
            element={
              <SalesLayout>
                <SalesProtected Cmp={SalesSettings} />
              </SalesLayout>
            }
          />

          {/*------------------------ Dashboard Routes ------------------------*/}
          <Route
            exact
            path="saleshome"
            element={
              <SalesLayout>
                <SalesProtected Cmp={SalesHome} />
              </SalesLayout>
            }
          />

          {/*------------------------ profile Routes ------------------------*/}
          <Route
            exact
            path="salesprofile"
            element={
              <SalesLayout>
                <SalesProtected Cmp={SalesAdminProfile} />
              </SalesLayout>
            }
          />

          {/*------------------------ manage sales type Routes ------------------------*/}
          <Route
            exact
            path="addsalestype"
            element={
              <SalesLayout>
                <SalesProtected Cmp={AddSalesType} />
              </SalesLayout>
            }
          />
          <Route
            exact
            path="addsalestype/:id"
            element={
              <SalesLayout>
                <SalesProtected Cmp={AddSalesType} />
              </SalesLayout>
            }
          />
          <Route
            exact
            path="viewsalestype"
            element={
              <SalesLayout>
                <SalesProtected Cmp={ViewSalesType} />
              </SalesLayout>
            }
          />

          {/*------------------------ manage employee Routes ------------------------*/}
          <Route
            exact
            path="addemployee"
            element={
              <SalesLayout>
                <SalesProtected Cmp={AddEmployee} />
              </SalesLayout>
            }
          />
          <Route
            exact
            path="addemployee/:id"
            element={
              <SalesLayout>
                <SalesProtected Cmp={AddEmployee} />
              </SalesLayout>
            }
          />
          <Route
            exact
            path="viewemployees"
            element={
              <SalesLayout>
                <SalesProtected Cmp={ViewEmployees} />
              </SalesLayout>
            }
          />
          <Route
            exact
            path="viewemployee/:id"
            element={
              <SalesLayout>
                <SalesProtected Cmp={ViewEmployee} />
              </SalesLayout>
            }
          />

          {/*------------------------ manage lead profile Routes ------------------------*/}
          <Route
            exact
            path="addleadprofile"
            element={
              <SalesLayout>
                <SalesProtected Cmp={AddLeadProfile} />
              </SalesLayout>
            }
          />
          <Route
            exact
            path="addleadprofile/:id"
            element={
              <SalesLayout>
                <SalesProtected Cmp={AddLeadProfile} />
              </SalesLayout>
            }
          />
          <Route
            exact
            path="viewleadprofiles"
            element={
              <SalesLayout>
                <SalesProtected Cmp={ViewLeadProfiles} />
              </SalesLayout>
            }
          />
          <Route
            exact
            path="viewleadprofile/:id"
            element={
              <SalesLayout>
                <SalesProtected Cmp={ViewLeadProfile} />
              </SalesLayout>
            }
          />
          <Route
            exact
            path="completedleads"
            element={
              <SalesLayout>
                <SalesProtected Cmp={CompletedLeads} />
              </SalesLayout>
            }
          />
          {/*------------------------ manage refferal Routes ------------------------*/}
          <Route
            exact
            path="addrefferal"
            element={
              <SalesLayout>
                <SalesProtected Cmp={AddReferal} />
              </SalesLayout>
            }
          />
          <Route
            exact
            path="viewrefferals"
            element={
              <SalesLayout>
                <SalesProtected Cmp={ViewReferal} />
              </SalesLayout>
            }
          />

          {/*------------------------ manage query Routes ------------------------*/}
          <Route
            exact
            path="viewqueries"
            element={
              <SalesLayout>
                <SalesProtected Cmp={ViewQueries} />
              </SalesLayout>
            }
          />
        </Routes>
      </BrowserRouter>
      {/* <IndexView /> */}
    </>
  );
}

export default App;
